import { render, staticRenderFns } from "./PDPProductFamilies.vue?vue&type=template&id=2f3ebca2&scoped=true"
import script from "./PDPProductFamilies.vue?vue&type=script&lang=js"
export * from "./PDPProductFamilies.vue?vue&type=script&lang=js"
import style0 from "./PDPProductFamilies.vue?vue&type=style&index=0&id=2f3ebca2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3ebca2",
  null
  
)

export default component.exports